export default __webpack_public_path__ + "static/media/Carolina@300x.15a35560.png";